"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _default = function _default(_ref) {
  var image = _ref.image;
  return _react["default"].createElement(_semanticUiReact.Grid.Column, {
    style: {
      padding: '0.3em'
    }
  }, _react["default"].createElement("div", {
    style: {
      backgroundImage: "url(".concat(image, ")"),
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      width: '100%',
      paddingTop: '100%'
    }
  }));
};

exports["default"] = _default;